import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import { selectCurrency } from "../../../features/user/userSlice";
import { formatNumber } from "../../../utils/tools";
import { Button, ButtonsContainerRetiro, ErrorSpan, Form, InputContainer } from "../DepositElements";
import PFpasarelas from '../../../assets/images/retiroPF1.png';
import RetiraPF from '../../../assets/images/RETIRACONPAGOFACIL.svg';

const FormPagoFacil = ({
  form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);
  const [entidades, setEntidades] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [monedas, setMonedas] = useState([]);
  
  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  // Función para realizar la solicitud GET para entidades
  const fetchEntidades = async () => {
    try {
      const response = await axios.get('https://app.masterbets365.com/API/pagofacil/index.php/Api/getListServicesWithdrwalWithPagoFacil/listarentidades');
      const entidadesHabilitadas = response.data?.response_data?.values?.EntidadesHabilitadas || [];
      setEntidades(entidadesHabilitadas);
    } catch (error) {
      console.error("Error fetching entidades:", error);
    }
  };

  // Función para realizar la solicitud GET para documentos
  const fetchDocumentos = async () => {
    try {
      const response = await axios.get('https://app.masterbets365.com/API/pagofacil/index.php/Api/getListServicesWithdrwalWithPagoFacil/listardocumentos');
      const documentosHabilitados = response.data?.response_data?.values || [];
      setDocumentos(documentosHabilitados);
    } catch (error) {
      console.error("Error fetching documentos:", error);
    }
  };

  // Función para realizar la solicitud GET para monedas
  const fetchMonedas = async () => {
    try {
      const response = await axios.get('https://app.masterbets365.com/API/pagofacil/index.php/Api/getListServicesWithdrwalWithPagoFacil/listarmonedas');
      const monedasHabilitadas = response.data?.response_data?.values || [];
      const monedaBoliviana = monedasHabilitadas.filter(moneda => moneda.tcNombre === "Bolivia Boliviano");
      setMonedas(monedaBoliviana);
    } catch (error) {
      console.error("Error fetching monedas:", error);
    }
  };

  useEffect(() => {
    fetchEntidades();
    fetchDocumentos();
    fetchMonedas();
  }, []);

  return (
    <Form>
      <InputContainer>
        <label>NOMBRE DEL BANCO:</label>
        <select value={form.financial_institution} onChange={handleChange} name='financial_institution'>
          <option disabled value=''>{t("deposit.lbl-bank")}</option>
          {entidades.map((entidad) => (
             <option key={entidad.tnEntidadFinanciera} value={`${entidad.tnEntidadFinanciera} - ${entidad.tcNombre}`}>{entidad.tcNombre}</option>
          ))}  
        </select>
      </InputContainer>
      <InputContainer>
        <label>{t('deposit.account-number')}:</label>
        <input type='text' placeholder={t('deposit.account-number')} name='bank_account' value={form.bank_account} onChange={handleChange} />
      </InputContainer>

      <InputContainer>
        <label>{t("deposit.documentType")}:</label>
        <select value={form.document_type_code} onChange={handleChange} name='document_type_code'>
          <option disabled value=''>{t("deposit.select-document-type")}</option>
          {documentos.map((documento) => (
            <option key={documento.tnTipoDocumento} value={documento.tnTipoDocumento}>{documento.tcNombre}</option>
          ))}
        </select>
      </InputContainer>

       <InputContainer>
        <label>{t("deposit.lbl-currency")}:</label>
        <select value={form.currency_code} onChange={handleChange} name='currency_code'>
          <option disabled value=''>{t("deposit.select-currency")}</option>
          {monedas.map((moneda) => (
            <option key={moneda.tnMoneda} value={moneda.tnMoneda}>{moneda.tcNombre}</option>
          ))}
        </select>
      </InputContainer>


      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto"
          value={form.monto}
          onChange={(e) => handleMonto(e)}
        />
        {monto < 50 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 50 {moneda}{" "}
          </ErrorSpan>
        )}
        {monto > 10000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 10.000 {moneda}{" "}
          </ErrorSpan>
        )}
      </InputContainer>
      <img src={RetiraPF} alt='RetiraMonnet' className={'tupa1'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      <img src={PFpasarelas} alt='Pasarelas Monnet' className={'tupa2'} style={{width:'100%', marginTop: '0.5%', marginLeft: '0.2%'}}/>
    
      <ButtonsContainerRetiro style={{marginTop:'-160px'}}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          disabled={loading || monto < 50 || monto > 10000}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainerRetiro>
    </Form>
  );
};

export default FormPagoFacil;
